// PREZENCE — App Layout
import React, { useState } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import Sidebar from './Sidebar';
import Topbar from './Topbar';
import Prezy from './Prezy';
import ConsentGate from './ConsentGate';

const PAGE_TITLES = {
  '/admin':                'Dashboard',
  '/admin/employees':      'Employees',
  '/admin/employees/add':  'Add Employee',
  '/admin/screenshots':    'Screenshot Viewer',
  '/admin/leaves':         'Leave Management',
  '/admin/activity':       'Activity Monitor',
  '/admin/reports':        'Reports & Analytics',
  '/admin/profile':        'My Profile',
  '/employee':             'My Dashboard',
  '/employee/attendance':  'My Attendance',
  '/employee/leaves':      'My Leaves',
  '/employee/activity':    'My Activity',
  '/employee/profile':     'My Profile',
  '/hr':                   'HR Dashboard',
  '/hr/leaves':            'Leave Approvals',
  '/hr/employees':         'Employees',
  '/hr/reports':           'Reports',
  '/hr/profile':           'My Profile',
};

export default function AppLayout() {
  const [collapsed, setCollapsed] = useState(false);
  const location = useLocation();
  const title = PAGE_TITLES[location.pathname] || 'Prezence';

  return (
    <div className="app-layout">
      <Sidebar collapsed={collapsed} setCollapsed={setCollapsed} />
      <div className="main-content">
        <Topbar title={title} />
        <div className="page-body">
          <ConsentGate>
            <Outlet />
          </ConsentGate>
        </div>
      </div>
      <Prezy />
    </div>
  );
}
